<template>
	<div class="g-page flex-column">
		<div style="position: fixed; top: -100px;">
			<input type="text" name="username">
			<input type="password" name="password">
		</div>
		
		<div class="g-head flex">
			<div class="logo flex-center-cross">
				<img :src="SAAS ? systemConfig.seller_logo : systemConfig.scs_logo" alt="">
			</div>
			<div class="flex-grow flex-between-center">
				<div class="search flex-center">
					<i class="icon tf-search"></i>
					<input v-model="searchKeyword" class="flex-grow" type="text" placeholder="快速搜索功能" @focus="searchHandle" @click.stop="showSearchList = searchList.length > 0">
					
					<ul v-show="showSearchList">
						<li v-for="(item, i) in searchList" :key="i" @click="navHandle(item)">
							<p>{{item.menu_name}}</p>
							<p><span><i class="tf tf-address"></i>{{item.menu_path}}</span></p>
						</li>
					</ul>
				</div>
					
				<div class="flex">
					<div v-for="(item, i) in handleList" :key="i" class="handle flex-center" :title="item.name" @click="item.handle()">
						<i class="tf" :class="[item.icon]"></i>
						<ins v-if="item.total" class="handle-count">{{item.total}}</ins>
						<ins v-if="item.warn" class="handle-warn">!</ins>
					</div>
					<div class="user-info flex-center">
						<div class="icon flex-center">
							<img src="@/assets/image/head_icon.jpg" alt="">
						</div>
						<span class="name">{{userInfo.stationed_name}} - [{{userInfo.user_realname}}]</span>
						<i class="tf tf-tri-down"></i>
						
						<div class="menu">
							<div class="item" @click="$refs.resetPsw.open()">修改密码</div>
							<div class="item" @click="logout">安全退出</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<div class="flex-grow flex">
			<div class="g-aside">
				<dl v-for="(menu, i) in navList" :key="i" class="item">
					<dt class="flex-center-cross" :class="{'link': menu.menu_unique_key}" @click="navHandle(menu)">
						<i class="icon" :class="menu.menu_ico"></i>
						<span class="flex-grow">{{menu.menu_name}}</span>
						<i v-if="menu.child_menu_list" class="tf-angle-down"></i>
					</dt>
					<dd v-if="menu.child_menu_list" class="flex-wrap">
						<a v-for="(item, j) in menu.child_menu_list" :key="j" @click="navHandle(item)">{{item.menu_name}}</a>
					</dd>
				</dl>
			</div>
			
			<div class="g-content flex-grow">
				<router-view></router-view>
			</div>
		</div>
		
		<c-dialog ref="resetPsw" title="修改密码" width="480" @resolve="resetPassword" @close="$refs.resetPswForm.clear()">
			<c-form ref="resetPswForm">
				<c-form-item label="旧密码" required>
					<c-input type="password" name="old_pwd"></c-input>
				</c-form-item>
				<c-form-item label="新密码" required>
					<c-input type="password" name="user_pwd"></c-input>
				</c-form-item>
				<c-form-item label="确认密码" required>
					<c-input type="password" name="confirm_pwd"></c-input>
				</c-form-item>
			</c-form>
		</c-dialog>
	</div>
</template>

<script>
	import {cryptoJs, debounce} from '@deanwu/vue-component-library'
	import {mapState} from 'vuex'
	import IM from '@/assets/script/im.js'
	import {TencentCloudChat, IMReady, IMUnready} from '@/assets/script/im.js'
	
	window.IM = IM;
	window.TencentCloudChat = TencentCloudChat;
	
	export default {
		name: 'App',
		
		data() {
			return {
				searchKeyword: '',
				showSearchList: false,
				searchList: [],

				IMState: false,
				messageTotal: 0
			}
		},
		
		computed: {
			...mapState(['systemConfig', 'userInfo', 'navList']),
			
			handleList() {
				let arr = [];

				arr.push({
					name: `客服消息${this.IMState ? '' : ' (离线)'}`,
					icon: 'tf-message',
					total: this.IMState ? this.messageTotal : 0,
					warn: !this.IMState,
					handle: () => {
						this.chatHandle();
					}
				});

				if (!this.SAAS && this.systemConfig.pc_enabled == 'ON' && this.systemConfig.pc_mall_url) {
					arr.push({
						name: '前往商城',
						icon: 'tf-mall',
						handle: () => {
							window.open(this.systemConfig.pc_mall_url);
						}
					});
				}
				return arr;
			}
		},
		
		watch: {
			searchKeyword() {
				this.searchHandle();
			},

			IMState(val) {
				if (!val) {
					this.$confirm({
						title: '客服会话已失效',
						message: '客服账号已在其它地方登录，您可以点击客服消息重新连接',
						buttonName: '我知道了',
						cancelButton: false,
						cancel: () => {
							location.reload();
						}
					})
				}
			}
		},

		mounted() {
			if (!this.SAAS) {
				IMReady(() => {
					this.IMState = true;
					this.messageTotal = IM.getTotalUnreadMessageCount();
					IM.on(TencentCloudChat.EVENT.TOTAL_UNREAD_MESSAGE_COUNT_UPDATED, event => {
						this.messageTotal = event.data;
					});
				});
				IMUnready(() => {
					this.IMState = false;
					this.postChatMessage('close');
				});
				window.addEventListener('message', this.chatMessage);
			}

			this._beforeUnload = () => {
				this.postChatMessage('close');
			};
			window.addEventListener('beforeunload', this._beforeUnload);
		},

		beforeDestroy() {
			IM.logout();
			this.postChatMessage('close');
			window.removeEventListener('message', this.chatMessage);
			window.removeEventListener('beforeunload', this._beforeUnload);
		},
		
		methods: {
			searchHandle: debounce(function() {
				this.searchRequest && this.searchRequest.abort();
				
				if (this.searchKeyword) {
					this.searchRequest = this.request({
						url: '/stationed/user/menu/search',
						data: {
							menu_keyword: this.searchKeyword.trim()
						},
						success: data => {
							this.showSearchList = data.length > 0;
							this.searchList = data;
						}
					});
				} else {
					this.showSearchList = false;
					this.searchList = [];
				}
			}, 200, false),

			chatHandle() {
				if (!this.IMState) {
					let loading = this.$loading();
					IMReady(() => {
						this.IMState = true;
						this.messageTotal = IM.getTotalUnreadMessageCount();
						IM.on(TencentCloudChat.EVENT.TOTAL_UNREAD_MESSAGE_COUNT_UPDATED, event => {
							this.messageTotal = event.data;
						});
						loading.close();
						this.chatHandle();
					});
				} else {
					if (this._chat) {
						this._chat.focus();
					} else {
						this._chat = window.open('/chat', '_blank', `width=1000,height=650,top=${(window.innerHeight-650)/2},left=${(window.innerWidth-1000)/2}`);
					}
				}
			},

			chatMessage({data: {event, data}}) {
				console.log('chat set:', event, data);
				if (event == 'close') {
					delete this._chat;
				} else if (event == 'order') {
					this.navigateTo(`/order_detail/${data}`)
				} else if (event == 'refund') {
					this.navigateTo(`/after_sale_detail/refund/${data}?refundType=1`)
				}
			},

			postChatMessage(event, data) {
				this._chat && this._chat.postMessage({event, data}, location.origin);
			},
			
			logout() {
				this.$confirm({
					message: '确定要退出登录吗？',
					resolve: () => {
						this.request({
							url: '/stationed/user/logout',
							loading: true,
							success: () => {
								this.$store.commit('setSession', '');
								this.navigateTo('/login');
							}
						});
					}
				});
			},
			
			navHandle(data) {
				console.log(data.menu_unique_key)
				if (data.menu_unique_key) {
					switch(data.menu_unique_key) {
					case 'm_product_apply':
						if (this.$route.path == '/product_list') {
							this.$emitBus('productApply');
						} else {
							this.$onBus('fromProductApply', fun => {
								fun();
								this.$offBus('fromProductApply');
							})
							this.navigateTo({
								path: '/product_list'
							});
						}
						break;
						
					case 'm_oss':
						this.navigateTo('/oss_manage', true);
						break;
						
					default:
						this.navigateTo({
							name: data.menu_unique_key
						})
					}
				}
				this.showSearchList = false;
				this.searchList = [];
			},
			
			resetPassword(stop) {
				stop();
				this.$refs.resetPswForm.submit({
					url: '/sys_user/update_pwd',
					rule: {
						old_pwd: '请填写旧密码',
						user_pwd: '请填写新密码',
						confirm_pwd: [{
							type: 'empty',
							message: '请在填写一次新密码'
						}, {
							type: 'function',
							fun: (value, data) => {
								return data.user_pwd == value
							},
							message: '两次输入的新密码不一致'
						}]
					},
					dataFormatter: data => {
						data.old_pwd = cryptoJs.MD5(data.old_pwd).toString();
						data.user_pwd = cryptoJs.MD5(data.user_pwd).toString();
						delete data.confirm_pwd;
						return data;
					},
					success: () => {
						this.$message({
							type: 'success',
							message: '密码修改成功'
						});
						this.$refs.resetPsw.close();
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.g-page {
		height: 100vh;
		
		.g-head {
			height: 60px;
			background: #004CBD;
			
			[saas] & {
				background: #323242;
			}
			
			.logo {
				width: 210px;
				margin-right: 15px;
				
				img {
					height: 44px;
					margin-left: 22px;
				}
			}
			
			.search {
				position: relative;
				width: 360px;
				height: 34px;
				border-radius: 17px;
				margin-left: 25px;
				background: rgba(255,255,255,.1);
				
				.icon {
					margin: 0 8px 0 12px;
					color: #fff;
					opacity: .3;
				}
				
				input {
					height: 100%;
					padding-right: 15px;
					font-size: 13px;
					color: #fff;
				}
				
				ul {
					z-index: 11;
					position: absolute;
					left: 0;
					right: 0;
					top: 100%;
					max-height: 500px;
					border: 1px solid #eee;
					overflow: auto;
					background: #fff;
					box-shadow: 0 2px 10px 0 rgba(0,0,0,.1);
					
					li {
						padding: 6px 18px;
						font-size: 13px;
						color: #333;
						line-height: 24px;
						cursor: pointer;
					
						&:hover {
							background: #f5f5f5;
						}
						
						&:nth-child(n+2) {
							border-top: 1px solid #eee;
						}
						
						span {
							color: #999;
							
							.tf {
								margin-right: 5px;
							}
						}
					}
				}
			}
			
			.handle {
				position: relative;
				width: 56px;
				height: 60px;
				font-size: 20px;
				color: #fff;
				cursor: pointer;
				
				.tf {
					opacity: .8;
				}

				&:hover .tf {
					opacity: 1;
				}

				&-count {
					position: absolute;
					left: 50%;
					top: 12px;
					box-sizing: border-box;
					min-width: 16px;
					border-radius: 8px;
					padding: 0 4px;
					line-height: 16px;
					font-size: 12px;
					text-align: center;
					color: #fff;
					background: #E81717;
				}

				&-warn {
					position: absolute;
					left: 50%;
					bottom: 16px;
					box-sizing: border-box;
					width: 14px;
					border-radius: 8px;
					line-height: 14px;
					font-size: 10px;
					text-align: center;
					color: #fff;
					background: #FFC000;
				}
			}
			
			.user-info {
				position: relative;
				height: 60px;
				padding: 0 20px;
				color: #fff;
				cursor: pointer;
				transition: all .3s ease;
				
				&:hover {
					.menu {
						display: block;
					}
				}
				
				.icon {
					width: 34px;
					height: 34px;
					border-radius: 100%;
					overflow: hidden;
					background: #000;
				}
				
				.name {
					margin: 0 6px 0 10px;
					font-size: 13px;
				}
				
				> .tf {
					font-size: 12px;
				}
				
				.menu {
					display: none;
					z-index: 12;
					position: absolute;
					left: 0;
					right: 0;
					top: 100%;
					padding: 8px 0;
					color: #000;
					background: #fff;
					box-shadow: 0 3px 10px 0 rgba(0,0,0,.15);
					
					.item {
						position: relative;
						padding: 0 10px 0 16px;
						line-height: 36px;
						font-size: 13px;
						color: #333;
						
						&:hover {
							background: #F5F5F5;
							theme-color(main);
							
							.theme-list {
								display: block;
							}
						}
						
						.tf {
							font-size: 12px;
							color: #333;
						}
						
						.theme-list {
							display: none;
							position: absolute;
							right: 100%;
							top: 0;
							width: 100px;
							padding: 8px 0;
							background: #fff;
							box-shadow: 0 3px 10px 0 rgba(0,0,0,.15);
						}
					}
				}
			}
		}
		
		.g-aside {
			width: 210px;
			overflow: auto;
			background: #fff;
			
			.item {
				border-bottom: 1px solid #eee;
				padding: 10px 0;
				margin: 0 10px;
				
				dt {
					height: 36px;
					padding: 0 8px;
					
					&.link {
						cursor: pointer;
						
						&:hover {
							color: var(--color-main);
						}
					}
					
					.icon {
						margin-right: 10px;
						font-size: 15px;
					}
				}
				
				dd {
					padding: 0 8px 8px;
					
					a {
						width: 48%;
						margin-top: 10px;
						line-height: 18px;
						font-size: 12px;
						color: #444;
						
						&:hover {
							color: var(--color-main);
						}
						
						&:nth-child(even) {
							margin-left: 4%;
						}
					}
				}
			}
		}
		
		.g-content {
			overflow: auto;
			background: #F5F4F7;
			
			>>> .c-page {
				padding: 15px 15px 0;
			}
		}
	}
</style>
